import { FeaturesCommonConfig } from "../types";

export const featuresCommon: FeaturesCommonConfig = {
  appVersion: "1.0.1",
};
